import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import cn from "classnames";
import axios from "axios";
import clientLogger from "../../../utils/clientLogger";
import "cropperjs/dist/cropper.css";
import {
  popUpImage,
  imagesData,
  aboutUs,
  loaderState,
  imageFrameState,
  imagesBlobState,
  currentLocationState,
  selectedShippingAddress,
} from "@atoms";
import {
  countState,
  imageCountState,
  framePricesState,
  defaultFramePriceState
} from "@atoms/priceCalc";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {useModal} from "@helpers/hooks/useModal";
import useWindowDimensions from "@helpers/hooks/windowDemensions";
import {removeImage, getImagesDB} from "@api";
import {
  useDiscountConfig,
} from "@helpers/discounts";
import MergeSnackbar from "../../Shared/components/MergeSnackbar";
import "./style.css";
import {useSecondModal} from "../../helpers/hooks/useSecondModal";
import {useUniversalFilterHandler} from "../../helpers/hooks/useUniversalFilterHandler";
import {netPriceState} from "../../Recoil/Atoms/priceCalc";
import UniversalFilterPrompt from "../../Shared/Modals/UniversalFilterPrompt";
import FrameSelector from "./components/FrameSelector";
import ImageLoader from "@shared/ImageLoader";
import ShippingIcon from "./components/ShippingIcon";
import MobileIcon from "./components/MobileIcon";
import {
  bwFilterState,
  bluewhiteFilterState,
  universalFilterPromptState,
  clientCroppedImagesState,
  croppedImagesState,
  imagesLoadingState,
  imageUploadState,
  validCoupon,
} from "../../Recoil/Atoms";
import DeliveryDateRange from './deliverydates';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const showUploadOptionsIconStyling = {
  color: "#087E63",
  bottom: "225px",
  position: "absolute",
};

const handleAboutUsModalStyling = {
  color: "black",
  top: "70px",
  position: "absolute",
  fontWeight: 300,
};

function getFrameSelected() {
  const frameSelected = localStorage.getItem("frameSelected");
  if (!frameSelected) return "classic";
  return frameSelected;
}

const ReviewImages = ({ preloadedData }) => {
  const [currentLocation, setCurrentLocation] = useRecoilState(currentLocationState);
  const [, setimageonpopup] = useRecoilState(popUpImage);
  const [images] = useRecoilState(imagesData);
  const [, setFirstLoader] = useState("block");
  const [loader] = useRecoilState(loaderState);
  const [uploadImages, setUploadImages] = useRecoilState(imageUploadState);
  const netPrice = useRecoilValue(netPriceState);
  const setSelectedCoupon = useSetRecoilState(validCoupon);
  const [croppedImages, setCroppedImages] = useRecoilState(croppedImagesState);
  const [finalPriceState, setFinalPriceState] = useState(0);
  const [hasTrackedAddToCart, setHasTrackedAddToCart] = useState(false);
  const [, settransac] = useState();
  const [, setloaderdis] = useState(false);
  const [socialopc] = useState("none");
  const [blobs, setBlobs] = useState([]);
  const [frameChoose, setFrameChoose] = useRecoilState(imageFrameState);
  const [imagesBlob] = useRecoilState(imagesBlobState);
  const [uploadGateHint, setUploadGateHint] = useState(false);

  const [framePrices] = useRecoilState(framePricesState);
  const [defaultFramePrice] = useRecoilState(defaultFramePriceState);
  const [isBwFilter, setIsBwFilter] = useRecoilState(bwFilterState);
  const [isBluewhiteFilter, setIsBluewhiteFilter] = useRecoilState(bluewhiteFilterState);
  const [universalFilterPrompt, setUniversalFilterPrompt] = useRecoilState(universalFilterPromptState);
  const { handleUniversalFilterApplyToAll, handleUniversalFilterApplyToCurrentOnly } = useUniversalFilterHandler();
  const [fromGallery, setFromGallery] = useState(false);
  const location = useLocation();

  const secondModal = useSecondModal();
  const [, setAboutUs] = useRecoilState(aboutUs);
  const { discountConfig, defaultCoupon } = useDiscountConfig();

  setFrameChoose(getFrameSelected());
  setCurrentLocation(window.location.pathname);

  const [count, setCount] = useRecoilState(countState);
  const [imagecount] = useRecoilState(imageCountState);
  const [isImagesLoading, setIsImagesLoading] = useRecoilState(imagesLoadingState);

  const {height, width} = useWindowDimensions();
  let navigate = useNavigate();
  const modal = useModal();
  
  // Get setters for imagesData and imagesBlobState
  const [, setImagesData] = useRecoilState(imagesData);
  const [, setImagesBlob] = useRecoilState(imagesBlobState);
  
  // Get setter for selectedShippingAddress
  const setAddress = useSetRecoilState(selectedShippingAddress);
  
  // Check if we're coming from the gallery URL
  useEffect(() => {
    if (location.state?.fromGallery) {
      setFromGallery(true);

      // If we have cart data from the gallery, use the frame type
      if (location.state.cartData?.frameType) {
        setFrameChoose(location.state.cartData.frameType);
        localStorage.setItem("frameSelected", location.state.cartData.frameType);
      }

      // Log that we're accessing from gallery
      const uid = localStorage.getItem("uniqueUserId") || "";
      const userEmail = localStorage.getItem("userEmail") || "";
      const logIdentifier = userEmail ? `[${uid}-${userEmail}]` : `[${uid}]`;
      clientLogger.debug(`${logIdentifier} Viewing images from gallery URL`);

      // Set the user information in the selectedShippingAddress Recoil state
      // Include checkBox: true to ensure the privacy/TOS checkbox is pre-accepted
      if (location.state.cartData?.userInfo) {
        clientLogger.debug(`${logIdentifier} Setting user information from cart data`);
        setAddress({
          ...location.state.cartData.userInfo,
          checkBox: true
        });
      }

      // If we have gallery images, set them in the imagesData state
      if (location.state.galleryImages && location.state.galleryImages.length > 0) {
        // Set the images from the gallery
        setImagesData(location.state.galleryImages);

        // Also set the blobs for the images
        const blobs = location.state.galleryImages.map(img => ({
          id: img.publicId,
          url: img.crop_image,
          cropUrl: img.crop_image,
          viewUrl: img.view_image
        }));
        setImagesBlob(blobs);

        clientLogger.debug(`${logIdentifier} Loaded ${location.state.galleryImages.length} images from gallery`);
      }
    }
  }, [location, setFrameChoose, setImagesData, setImagesBlob, setAddress]);

  // Sync current frame selection to cart on mount to prevent frame mismatch
  // This handles the case where localStorage has a frame selection (e.g., "ever")
  // but the cart was created with the default "classic" and the user never clicked the frame selector
  useEffect(() => {
    const syncFrameToCart = async () => {
      const sessionId = localStorage.getItem("sessionId");
      const currentFrame = getFrameSelected();
      if (sessionId && currentFrame) {
        try {
          await axios.put(
            `${BASE_URL}/addtocart/session/${sessionId}`,
            { frameType: currentFrame }
          );
        } catch (err) {
          // Silent fail - non-critical sync
        }
      }
    };
    syncFrameToCart();
  }, []);
  const Frames = [
    { name: "classic", text: "קלאסי" },
    { name: "bold", text: "נועז", label: "פופולארי" },
    { name: "ever", text: "נקי" },
    { name: "clean", text: "אותנטי" },
    { name: "village", text: "כפרי" },
    { name: "nordic", text: "נורדי" },
  ];
  const selectedFrameText = Frames.find(frame => frame.name === frameChoose)?.text;
  useEffect(() => {
    if (imagesBlob.length === 0) {
      return setIsImagesLoading(false);
    }

    setIsImagesLoading(true);
  }, [imagesBlob]);

  useEffect(() => {
    setBlobs((prevState) => {
      if (prevState.length === 0) {
        return [...imagesBlob];
      }
      const newArr = [...prevState];
      if (imagesBlob.length > 0) {
        imagesBlob.forEach((blob) => {
          const existingIndex = newArr.findIndex((im) => im.id === blob.id);
          if (existingIndex === -1) {
            newArr.push(blob);
          } else if (newArr[existingIndex].url !== blob.url) {
            // Placeholder tiles start with url:null and get their preview URL
            // patched in later (batch reveal) — refresh the stored copy so the
            // blob preview still shows while the server image loads.
            newArr[existingIndex] = { ...newArr[existingIndex], ...blob };
          }
        });
      }
      return newArr;
    });
  }, [imagesBlob]);

  // Get the current frame type and its price
  const currentFrameType = frameChoose || localStorage.getItem("frameSelected") || "classic";
  const framePrice = framePrices[currentFrameType] || defaultFramePrice;

  const checkValidCoupon = useCallback(() => {
    const totalImageCount = imagecount + imagesBlob.length;
    const price = netPrice + (imagesBlob.length * framePrice);

    const maxDiscountAmountAvailable = Object.keys(discountConfig)
      .sort((a, b) => Number(b) - Number(a))
      .find((key) => Number(key) <= totalImageCount);

    if (!maxDiscountAmountAvailable) {
      setSelectedCoupon(null);
      return;
    }

    const currentDiscountConfig = discountConfig[maxDiscountAmountAvailable];

    if (!currentDiscountConfig.enableDefault) {
      // Check if fallbackToLower is enabled
      if (currentDiscountConfig.fallbackToLower) {
        // Find the closest lower tier with enableDefault: true
        const lowerTier = Object.keys(discountConfig)
          .map(key => Number(key))
          .filter(key => key < Number(maxDiscountAmountAvailable) && discountConfig[key].enableDefault)
          .sort((a, b) => b - a)[0]; // Sort descending and take the first (highest) value
        
        if (lowerTier) {
          // Apply the fallback discount
          const fallbackDiscount = discountConfig[lowerTier].discount;
          const fallbackPrice = price * (fallbackDiscount / 100);
          
          setFinalPriceState(fallbackPrice);
          
          setSelectedCoupon({
            coupon: defaultCoupon,
            discount: fallbackDiscount,
            discountPrice: fallbackPrice,
            isFallback: true
          });
          return;
        }
      }
      
      setSelectedCoupon(null);
      return;
    }

    const finalPrice = price * (currentDiscountConfig.discount / 100);

    setFinalPriceState(finalPrice);

    setSelectedCoupon(
      {
        coupon: defaultCoupon,
        discount: currentDiscountConfig.discount,
        discountPrice: finalPrice,
      });

  }, [imagesBlob.length, netPrice, setSelectedCoupon, framePrice]);

  useEffect(() => {
    checkValidCoupon();
  }, [checkValidCoupon]);

  const setFrameSelected = (frame) => {
    localStorage.setItem("frameSelected", frame);
    setFrameChoose(frame);
  };
  const storagedata = localStorage.getItem("uniqueUserId");
  if (!storagedata) {
    navigate("/");
  }

  const handleAboutUsModal = (type) => {
    setAboutUs(type);
    if (width > 768) {
      secondModal("open", "aboutUs");
    } else {
      secondModal("open", "aboutUsMobile");
    }
  };

  const keep_image = (id) => {
    // Get email from localStorage if available
    const userEmail = localStorage.getItem("userEmail") || "";
    
    // Log with the [uid-email] format if email is available
    const uid = localStorage.getItem("uniqueUserId") || "";
    const logIdentifier = userEmail ? `[${uid}-${userEmail}]` : `[${uid}]`;
    clientLogger.debug(`${logIdentifier} Keeping image with ID: ${id}`);
    
    const sessionId = localStorage.getItem("sessionId") || "";
    axios.put(BASE_URL + "/image_keep/" + id, { email: userEmail, sessionId }).then((v) => {
    });
  };

  useEffect(() => {
    setloaderdis(true);
    getimagesdb();
    
    // Ensure first image is visible on desktop
    if (width > 767) {
      setTimeout(() => {
        const albumElement = document.getElementById("my-album-id");
        if (albumElement) {
          albumElement.scrollLeft = 0; // Reset scroll position to show first image
        }
      }, 300); // Small delay to ensure the component is fully rendered
    }
  }, [width]);
  
    // Add this to your React component
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://hf.tranzila.com/assets/js/thfapplepay.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if ((imagecount + imagesBlob.length > 0) && !hasTrackedAddToCart) {
      // Facebook Pixel tracking
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          value: netPrice + (imagesBlob.length * framePrice),
          currency: 'ILS',
          content_type: 'product',
          contents: [{
            quantity: imagecount + imagesBlob.length
          }]
        });
      }
      
      // TikTok Pixel tracking
      if (window.ttq) {
        window.ttq.track('AddToCart', {
          content_id: 'blends-frames',
          content_type: 'product',
          content_name: 'Blends Frames',
          quantity: imagecount + imagesBlob.length,
          price: netPrice + (imagesBlob.length * framePrice),
          value: netPrice + (imagesBlob.length * framePrice),
          currency: 'ILS',
        });
      }
      
      // Add GA4 tracking
      if (window.gtag) {
        window.gtag('event', 'add_to_cart', {
          currency: 'ILS',
          value: netPrice + (imagesBlob.length * framePrice),
          items: [{
            item_name: 'Blends Frame',
            quantity: imagecount + imagesBlob.length,
            price: framePrice
          }]
        });
      }
    
      setHasTrackedAddToCart(true);
    }
  }, [imagecount, imagesBlob.length, netPrice, hasTrackedAddToCart, framePrice]);

  useEffect(() => {
    const lowImage = images.find((i) => (i.imageheight < 800 && i.imagewidth < 800) && !i.keepImage);
    if (lowImage) {
      modal("open", "deleteConfirm", {
        data: lowImage,
        onKeepImage: (id) => keep_image(id),
        onDelete: () =>
          removeImage(lowImage._id).then(() => {
            setCount(count + 1);
            getImagesDB().then((res) => {
              if (res.data.data.length === 0) {
                localStorage.setItem("dataExist", 0);
                navigate("/upload-your-image");
              }
            });
          }),
      });
    }
  }, [images]);

  const handleFilterUpdate = async () => {
    try {
      const localstr = localStorage.getItem("uniqueUserId");
      const sessionId = localStorage.getItem("sessionId") || "";
      const userEmail = localStorage.getItem("userEmail") || "";
      const logIdentifier = userEmail ? `[${localstr}-${userEmail}]` : `[${localstr}]`;
      
      clientLogger.debug(`${logIdentifier} Updating B&W filter to: ${isBwFilter ? 'enabled' : 'disabled'}`);
      
      // Ensure mutual exclusion: turn off bluewhite filter when applying BW to all
      setIsBluewhiteFilter(false);
      
      if(isBwFilter) {
        await axios.post(`${BASE_URL}/add-bw-filter/${localstr}`, {
          sessionId,
          email: userEmail
        });
      } else {
        await axios.post(`${BASE_URL}/remove-bw-filter/${localstr}`, {
          sessionId,
          email: userEmail
        });
      }

      await getImagesDB();
      
      // NOTE: We no longer clear client-side crops because they are now unfiltered
      // and filters are applied via CSS only

      // Filter update completed successfully
      clientLogger.debug(`${logIdentifier} B&W filter update completed`);
    } catch (err) {
      console.error(`Error updating B&W filter: ${err.message}`);
    }
  }

  const handleBluewhiteFilterUpdate = async () => {
    try {
      const localstr = localStorage.getItem("uniqueUserId");
      const sessionId = localStorage.getItem("sessionId") || "";
      const userEmail = localStorage.getItem("userEmail") || "";
      const logIdentifier = userEmail ? `[${localstr}-${userEmail}]` : `[${localstr}]`;
      
      clientLogger.debug(`${logIdentifier} Updating bluewhite filter to: ${isBluewhiteFilter ? 'enabled' : 'disabled'}`);
      
      // Ensure mutual exclusion: turn off BW filter when applying bluewhite to all
      setIsBwFilter(false);
      
      if(isBluewhiteFilter) {
        await axios.post(`${BASE_URL}/add-bluewhite-filter/${localstr}`, {
          sessionId,
          email: userEmail
        });
      } else {
        await axios.post(`${BASE_URL}/remove-bluewhite-filter/${localstr}`, {
          sessionId,
          email: userEmail
        });
      }

      await getImagesDB();
      
      // NOTE: We no longer clear client-side crops because they are now unfiltered
      // and filters are applied via CSS only

      // Filter update completed successfully
      clientLogger.debug(`${logIdentifier} Bluewhite filter update completed`);
    } catch (err) {
      console.error(`Error updating bluewhite filter: ${err.message}`);
    }
  }

  const edit_seg = (e, correspondingBlob, imagesBlob) => {
    setimageonpopup(e);
    modal("open", "editImage", {frame: frameChoose, correspondingBlob: correspondingBlob, imagesBlob: imagesBlob});
  };

  const getimagesdb = () => {
    getImagesDB().then((res) => {
      setFirstLoader("none");
      settransac("none");
      setloaderdis(false);
    });
  };

  const deleteImage = (item) => {
    const id = item._id;
    removeImage(id).then((v) => {
      setCount(count + 1);
      getImagesDB().then((res) => {
        if (res.data.data.length === 0) {
          localStorage.setItem("dataExist", 0);
          navigate("/upload-your-image");
          window.location.reload(true);
        }
      });
    });
  };

  const frameSelected = useCallback(async (type) => {
    setFrameSelected(type);
    const userid = localStorage.getItem("uniqueUserId");
    const sessionId = localStorage.getItem("sessionId");

    // Update the frame type in the uploadimg collection
    const response = await axios.post(
      BASE_URL + "/frameselected",
      {
        userid,
        type,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      },
    );

    // Also update the frameType in the addtocart collection if sessionId exists
    if (sessionId) {
      try {
        const userEmail = localStorage.getItem("userEmail") || "";
        const logIdentifier = userEmail ? `[${userid}-${userEmail}]` : `[${userid}]`;
        clientLogger.debug(`${logIdentifier} Updating frameType to: ${type}`);
        
        const cartResponse = await axios.put(
          `${BASE_URL}/addtocart/session/${sessionId}`,
          {
            frameType: type
          },
          {
            headers: {
              "content-type": "application/json",
            },
          }
        );
        
        clientLogger.debug(`${logIdentifier} frameType updated successfully`);
      } catch (error) {
        console.error(`Error updating frameType: ${error.message}`);
      }
    }
  }, []);

  const showUploadOptions = () => {
    modal("open", "uploadOptions", {}, 400);
  };

  const openImageOptions = (img, correspondingBlob, imagesBlob, isBlob, isCropped) => {
    if (width > 767) return;
    modal("open", "imageOptions", {
      editImage: () => edit_seg(img, correspondingBlob, imagesBlob),
      deleteImage: () => deleteImage(img),
      isBlob: isBlob,
      isCropped: isCropped,
    });
  };

  // Checkout is gated on every picked image being CONFIRMED by the server.
  // Blob entries carrying uploadStatus ('pending'/'failed') exist only until the
  // server ack removes them (getImagesDB) — so any such entry means an image the
  // user sees but the server doesn't have. Letting checkout through here is how
  // people paid for photos that never arrived.
  const guardUnsyncedUploads = () => {
    const unsynced = imagesBlob.some((b) => b.uploadStatus);
    if (unsynced) {
      setUploadGateHint(true);
      setTimeout(() => setUploadGateHint(false), 3500);
    }
    return unsynced;
  };

  const openCheckoutDrawer = () => {
    if (guardUnsyncedUploads()) return;
    modal("open", "checkout");
  };

  const openCheckoutDrawerMobile = () => {
    if (guardUnsyncedUploads()) return;
    modal("open", "mobileCheckout");
  };

  if (currentLocation === "/review-your-images" && uploadImages) {
    // Adding to an EXISTING gallery: glide to the end so the new batch's
    // train entrance happens in view (owner: otherwise it plays off-screen).
    // Fresh strip: stay put — the train arrives from the right at the start.
    const albumElement = document.getElementById("my-album-id");
    if (albumElement && images.length > 0) {
      albumElement.scrollTo({ left: albumElement.scrollWidth, behavior: "smooth" });
    }
    setTimeout(() => {
      setUploadImages(false);
    }, 500);
  }


  const numOfframes = [imagecount + imagesBlob.length];
  let priceBeforediscount = numOfframes * framePrice;
  let difference = priceBeforediscount - finalPriceState;
  const [clientCroppedImages, setClientCroppedImages] = useRecoilState(clientCroppedImagesState);

  // Drag to scroll functionality for desktop
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    if (width <= 767) return; // Only enable on desktop
    setIsDragging(true);
    const albumElement = document.getElementById("my-album-id");
    setStartX(e.pageX - albumElement.offsetLeft);
    setScrollLeft(albumElement.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging || width <= 767) return;
    e.preventDefault();
    const albumElement = document.getElementById("my-album-id");
    const x = e.pageX - albumElement.offsetLeft;
    const walk = (x - startX) * 2.5; // Increased scroll speed multiplier for better responsiveness
    albumElement.scrollLeft = scrollLeft - walk;
  };

  // Fetch client-side cropped images from addtocart collection on component mount
  useEffect(() => {
    const fetchClientCroppedImagesFromCart = async () => {
      try {
        const sessionId = localStorage.getItem("sessionId");
        const uid = localStorage.getItem("uniqueUserId");
        const userEmail = localStorage.getItem("userEmail") || "";
        const logIdentifier = userEmail ? `[${uid}-${userEmail}]` : `[${uid}]`;
        
        if (!sessionId) {
          clientLogger.debug(`${logIdentifier} No sessionId found, skipping client-cropped images fetch`);
          return;
        }
        
        clientLogger.debug(`${logIdentifier} Fetching client-cropped images from cart`);
        
        const response = await axios.get(`${BASE_URL}/api/addtocart/session/${sessionId}`);
        
        if (response.data.success && response.data.cart && response.data.cart.images) {
          const cartImages = response.data.cart.images;
          const newClientCroppedImages = {};
          
          // Extract client-cropped images from cart
          cartImages.forEach(cartImage => {
            if (cartImage.clientCroppedImage && !cartImage.isDeleted) {
              // Find the corresponding image in our images array to get the _id
              const matchingImage = images.find(img => img.publicId === cartImage.imageId);
              
              if (matchingImage) {
                // Store using both _id and publicId as keys for maximum compatibility
                newClientCroppedImages[matchingImage._id] = cartImage.clientCroppedImage;
                newClientCroppedImages[cartImage.imageId] = cartImage.clientCroppedImage;
                clientLogger.debug(`${logIdentifier} Retrieved client-cropped image for: ${matchingImage._id}`);
              }
            }
          });
          
          // Update the clientCroppedImages state with the retrieved images
          if (Object.keys(newClientCroppedImages).length > 0) {
            clientLogger.debug(`${logIdentifier} Retrieved ${Object.keys(newClientCroppedImages).length} client-cropped images from cart`);
            setClientCroppedImages(prevState => ({
              ...prevState,
              ...newClientCroppedImages
            }));
          } else {
            clientLogger.debug(`${logIdentifier} No client-cropped images found in cart`);
          }
        }
      } catch (error) {
        console.error(`Error fetching client-cropped images: ${error.message}`);
      }
    };
    
    fetchClientCroppedImagesFromCart();
  }, [images, setClientCroppedImages]);
  

  const renderImages = useMemo(() => {
    // Every picked file gets a tile IMMEDIATELY (owner call, replaces the
    // batch-wide HeartLoader): a clear preview appears the moment the file
    // is decoded, with a corner spinner appearing only past 5s unconfirmed.
    // Dedupe by identity: right after an ack the server copy exists BEFORE the
    // blob entry is filtered out — rendering both would duplicate the tile and
    // shift every index after it for a frame.
    const serverIds = new Set(images.map((im) => im.publicId));
    const concatenatedArray = [...images, ...imagesBlob.filter((b) => !serverIds.has(b.id))]
      .sort((firstImage, secondImage) => firstImage.uploadedAt - secondImage.uploadedAt);


    return concatenatedArray.map((im, index) => {
      const correspondingBlob = blobs.find(blob => blob.id === im.publicId);
      
      // Check if we have a client-side cropped image for this image
      // Try both _id and publicId as keys
      const imageId = im._id || '';
      const publicId = im.publicId || '';
      
      const hasClientCrop = clientCroppedImages && 
        (clientCroppedImages[imageId] || clientCroppedImages[publicId]);
      
      // Determine the source to use
      let imageSrc;
      if (hasClientCrop) {
        // Use client-side cropped image if available
        // Try both _id and publicId as keys
        imageSrc = clientCroppedImages[imageId] || clientCroppedImages[publicId];

        // We'll use a timestamp in the key prop instead of modifying the object
      } else if (imagesBlob.includes(im)) {
        // Use blob URL for newly uploaded images
        imageSrc = im.url;
      } else {
        // Prefer the small server-generated display derivative (view_image) for a
        // fast grid; fall back to the full-res crop for legacy rows where they're equal.
        imageSrc = im.view_image || im.crop_image;
      }
      
      const isLowRes = im.imageheight && im.imagewidth && im.imageheight < 800 && im.imagewidth < 800;

      // Not yet on the server: blurred local preview + spinner until the server
      // acks the upload (then the blob is removed and the sharp server tile
      // takes its place). The blur both signals "not saved yet" and masks the
      // center-crop -> face-crop shift when detection lands. No preview yet
      // (still decoding / undecodable HEIC) -> plain white + spinner.
      // (If the upload can't complete within its window, the entry is dropped
      // and this frame simply disappears; a refresh drops unconfirmed too.)
      if (im.uploadStatus || im.processing) {
        return (
          // Keyed by the SAME identity the server tile will use (blob id ===
          // publicId), so the ack swap re-uses this DOM node instead of
          // remounting the tile and replaying its entrance animation.
          <div className={`album-item-wrapper`} key={`tile-${im.id}`}>
            <div className="album-item-shadow"></div>
            {/* POSITIONAL SLOT — must mirror the server tile's {isLowRes && ...}
                child so .album-item sits at the SAME child index in both
                branches. Without it React remounts the frame div on the ack
                swap and its popUp animation replays (the visible tile jump —
                proven by an animationstart probe, e2e/_verify-tiles.cjs). */}
            {false}
            {/* key MUST match the server branch's frame key: a keyed element
                never reconciles with an unkeyed one, so without it the frame
                remounts at ack and popUp replays even with aligned positions. */}
            <div className={cn(`album-item pop-up ${frameChoose}`)} key={`${frameChoose}`}></div>
            {/* Sibling of album-item, exactly like ImageLoader's <img> — the
                per-frame .img-con rules position it inside the frame window. */}
            <div className={cn(`img-con ${frameChoose} up-white`)}>
              {im.url ? (
                <img
                  src={im.url}
                  alt=""
                  className="up-preview"
                  draggable={false}
                  onError={(ev) => { ev.currentTarget.style.display = "none"; }}
                />
              ) : null}
              <span className="up-spin" role="status" aria-label="מעלה תמונה" />
            </div>
          </div>
        );
      }

      return (
        // Stable identity key (NOT the list index): an acked upload keeps the
        // exact key its pending tile had (blob id === publicId), so React
        // re-uses the DOM node — no remount, no pop-in replay — and acks or
        // deletes elsewhere in the list can't remount the tiles after them.
        <div
          className={cn("album-item-wrapper", { "pop-in": imagesBlob.includes(im) })}
          key={`tile-${im.publicId || im._id || index}`}
        >
          <div className="album-item-shadow"></div>
          {isLowRes && (
            <div className="low-res-badge" title="תמונה באיכות נמוכה">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
          )}
          {/* <div className="album-item-dimension">
            <p>20x20</p>
            </div> */}
          <div
            className={cn(`album-item pop-up ${frameChoose}`)}
            key={`${frameChoose}`}
            onClick={() => {
              openImageOptions(im, correspondingBlob, imagesBlob, imagesBlob.includes(im),
                croppedImages.some(img => img._id === im._id));
            }}
          >
            {width > 767 && (
              <div className={`content-overlay ${frameChoose}`}>
                <div className="content-details fadeIn-bottom">
                  <img
                    src="/assets/file/images/edit_image.svg"
                    className="עריכת תמונה"
                    data-toggle="modal"
                    data-target="#myModal"
                    onClick={() => {
                      edit_seg(im, correspondingBlob, imagesBlob);
                    }}
                    alt="edit"
                  />
                  <>
                    <img
                      src="/assets/file/images/Delete_icon.svg"
                      className={`edit ${(imagesBlob.includes(im) || croppedImages.some(img => img._id === im._id)) &&
                      "disabled"}`}
                      alt="הסרת תמונה"
                      onClick={() => {
                        if (imagesBlob.includes(im) || croppedImages.some(img => img._id === im._id)) {
                          return;
                        }
                        deleteImage(im);
                      }}
                    />
                  </>
                </div>
              </div>
            )}
          </div>
          <ImageLoader
            loadingBlob={correspondingBlob ? correspondingBlob.url : undefined}
            loading={false}
            src={imageSrc}
            zoomvalue={!imagesBlob.includes(im) && im.zoomvalue}
            bwFilter={im ? im.bwFilter : false}
            bluewhiteFilter={im ? im.bluewhiteFilter : false}
            loaderClassName={cn(`img-con ${frameChoose} blurred-loader-image ${frameChoose}`)}
            className={cn(`img-con ${frameChoose}`)}
            alt="icon"
            shadow={true}
            // Add a key that includes a timestamp for client-cropped images to force re-render
            key={`image-${im._id || im.publicId}-${hasClientCrop ? new Date().getTime() : 'server'}`}
          />
        </div>
      );
    });
  }, [images, imagesBlob, blobs, frameChoose, width, openImageOptions, edit_seg, deleteImage, clientCroppedImages]);

  // Center batch spinner retired (owner call): tiles render instantly with
  // their own blurred preview + spinner, so a batch-wide overlay would just
  // cover them. The measurement effect below self-disables on `false`.
  const isBatchProcessing = false;

  // Batch spinner is centered in the VISIBLE ALBUM AREA on every device: from
  // the bottom of whatever sits above the album (the delivery-date strip when
  // shown, else the header) down to the top of the fixed bottom bar. That is
  // exactly where the tiles are centered by .my-album's align-items:center, and
  // it also holds when NO tile is rendered yet (first batch: the album is
  // empty while it processes — the case QA saw sitting too high). Measured at
  // runtime because the strip and the bar both vary by content/device.
  useEffect(() => {
    if (!isBatchProcessing) return undefined;
    const root = document.documentElement;
    const measure = () => {
      const strip = document.querySelector(".delivery-date-range");
      const header = document.querySelector("header");
      const bar = document.querySelector(".mobile-checkout");
      const stripRect = strip ? strip.getBoundingClientRect() : null;
      const top = stripRect && stripRect.height > 0
        ? stripRect.bottom
        : header ? header.getBoundingClientRect().bottom : 48;
      const bottom = bar ? bar.getBoundingClientRect().top : window.innerHeight;
      root.style.setProperty("--rv-spinner-cy", `${Math.round((top + bottom) / 2)}px`);
    };
    measure();
    window.addEventListener("resize", measure);
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    if (ro) {
      const bar = document.querySelector(".mobile-checkout");
      const strip = document.querySelector(".delivery-date-range");
      if (bar) ro.observe(bar);
      if (strip) ro.observe(strip);
    }
    return () => {
      window.removeEventListener("resize", measure);
      if (ro) ro.disconnect();
    };
  }, [isBatchProcessing]);

  return (
    <>
      <MergeSnackbar />
      {uploadGateHint && (
        <div className="up-toast" role="status">התמונות עדיין נשמרות — עוד רגע ואפשר להמשיך לתשלום</div>
      )}
      <UniversalFilterPrompt
        show={universalFilterPrompt.show}
        changeType={universalFilterPrompt.changeType}
        filterType={universalFilterPrompt.filterType}
        onApplyToAll={handleUniversalFilterApplyToAll}
        onApplyToCurrentOnly={handleUniversalFilterApplyToCurrentOnly}
        onClose={handleUniversalFilterApplyToCurrentOnly}
      />
      {/* WhatsApp button - top left (mobile) */}
      {width < 768 && (
        <div className="review-whatsapp-button">
          <img
            src="/assets/images/wtsap.svg"
            alt="WhatsApp"
            onClick={() => secondModal('open', 'whatsAppMobile')}
            style={{cursor: "pointer"}}
          />
        </div>
      )}
      <div className="reviews-info-mobile-cart">
        <div className="svg-container" onClick={width > 767 ? openCheckoutDrawer : openCheckoutDrawerMobile}>
          <img src="/assets/images/cart.svg" alt=""/>
          <span className={imagecount + imagesBlob.length >= 10 ? "overlay-text-10" : "overlay-text"}>
          {imagecount + imagesBlob.length}
          </span>
        </div>
      <div className="review-infos-mobile-top">
      <div className="review-infos-mobile">
      <div className="prices-container">
      {/* <p onClick={() => handleAboutUsModal("CQ")} text="?">יש לכם שאלה?</p> */}
      {imagecount + imagesBlob.length >= 6 ? (
        <>
          <span className="difference">
            ₪{Number.isInteger(difference) ? Math.floor(difference) : difference.toFixed(1)}
          </span>
          <span className="price-strikethrough">
            ₪{Number.isInteger(priceBeforediscount) ? Math.floor(priceBeforediscount) : priceBeforediscount.toFixed(1)}
          </span>
        </>
      ) : (
        <span className="difference">
          ₪{Number.isInteger(priceBeforediscount) ? Math.floor(priceBeforediscount) : priceBeforediscount.toFixed(1)}
        </span>
      )}
    </div>
      <span className="delivery-date-range"><DeliveryDateRange/></span>
    </div>
    </div>
    </div>
      <div className="review-images-wrapper" style={{maxHeight: width < 768 ? height - 305 : null}}>
        <div className="trx">
          <div
            id={"my-album-id"}
            className={cn("my-album", {single: images.length + imagesBlob.length <= 1})}
            style={{
              gridTemplateColumns:
                width <= 767 ? `repeat(${images.length + imagesBlob.length}, 250px)` : null,
              cursor: width > 767 ? (isDragging ? 'grabbing' : 'grab') : 'default',
            }}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
          >
            {renderImages}
            {/* One green spinner centered over the TILE AREA while a picked batch is
                being downscaled/face-detected; the batch's tiles then pop in
                together. Absolute child of .my-album so it centers on the tiles'
                own box (not the 100vh .trx, whose center is the SCREEN center —
                visibly below the tiles), independent of the row's flex-start. */}
            {isBatchProcessing && (
              <div className="album-batch-spinner" aria-label="loading" role="status">
                <div className="album-batch-spinner__circle" />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mobile-checkout">
        <div>
          <FrameSelector
            frameChoose={frameChoose}
            frameSelected={frameSelected}
          />
        </div>

        <MobileIcon styling={showUploadOptionsIconStyling} onClick={() => showUploadOptions()} text="+" />

        <div className="mobile-checkout-info">
          {imagecount + imagesBlob.length >= 5 &&
            <p style={{marginTop: "13px", fontWeight: "400"}}>
              <img src="https://www.facebook.com/tr?id=266939557094379&ev=UploadedImages" height="1" width="1"
                   alt="" />
               <img src="/assets/images/shipping-green.svg" alt="check"
                   style={{width: "20px"}} />&nbsp;
               מעולה! קיבלתם שליח עד הבית ללא עלות
            </p>
          }
          {imagecount + imagesBlob.length === 4 &&
            <p style={{color: "#727272"}}>
              <img src="https://www.facebook.com/tr?id=266939557094379&ev=UploadedImages" height="1" width="1"
                   alt="" />
              <img className="notice" src="assets/images/review-notice.svg" alt="" />&nbsp;&nbsp; תוסיפו עוד תמונה אחת
              וקבלו משלוח בחינם
            </p>
          }
          {imagecount + imagesBlob.length === 3 &&
            <p style={{color: "#727272"}}>
              <img src="https://www.facebook.com/tr?id=266939557094379&ev=UploadedImages" height="1" width="1"
                   alt="" />
              <img className="notice" src="assets/images/review-notice.svg" alt="" />&nbsp;&nbsp; תוסיפו עוד 2 תמונות
              וקבלו משלוח בחינם
            </p>
          }
          {imagecount + imagesBlob.length === 2 &&
            <p style={{color: "#727272"}}>
              <img src="https://www.facebook.com/tr?id=266939557094379&ev=UploadedImages" height="1" width="1"
                   alt="" />
              <img className="notice" src="assets/images/review-notice.svg" alt="" />&nbsp;&nbsp; תוסיפו עוד 3 תמונות
              וקבלו משלוח בחינם
            </p>
          }
          {imagecount + imagesBlob.length === 1 &&

            <p style={{color: "#727272"}}>
              <img src="https://www.facebook.com/tr?id=266939557094379&ev=UploadedImages" height="1" width="1"
                   alt="" />
              <img className="notice" src="assets/images/review-notice.svg" alt="" />&nbsp;&nbsp; תוסיפו עוד 4 תמונות
              וקבלו משלוח בחינם
            </p>

          }
        </div>
        <div className="mobile-checkout-button" style={{width: "60%", display: "flex", justifyContent: "center", alignItems: "center", margin: "auto"}}>
          {imagecount + imagesBlob.length === 0 &&
            <button
              className="mobile-checkout-btn"
              data-toggle="modal"
              data-target="#rescart"
              onClick={showUploadOptions}
            >
              בחירת תמונות
            </button>
          }
          {imagecount + imagesBlob.length > 1 &&
            <button
              className="mobile-checkout-btn"
              data-toggle="modal"
              data-target="#rescart"
              onClick={width > 767 ? openCheckoutDrawer : openCheckoutDrawerMobile}
            >
              {/* מעבר לעגלה ({imagecount + imagesBlob.length} תמונות) */}
              סיכום ומשלוח
            </button>
          }
          {imagecount + imagesBlob.length === 1 &&
            <button
              className="mobile-checkout-btn"
              data-toggle="modal"
              data-target="#rescart"
              onClick={width > 767 ? openCheckoutDrawer : openCheckoutDrawerMobile}
            >
              {/* המשך לעגלה עם תמונה אחת */}
              סיכום ומשלוח
            </button>
          }
        </div>
      </div>
      <div className="body_opcy" style={{display: socialopc}}></div>
    </>
  );
};

export default ReviewImages;
